// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LoadMoreButton_button__2xY7v {\n  margin: 20px 0;\n}\n", "",{"version":3,"sources":["webpack://./src/views/Search/SearchDesktop/Content/Calendar/LoadMoreButton.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB","sourcesContent":[".button {\n  margin: 20px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "LoadMoreButton_button__2xY7v"
};
export default ___CSS_LOADER_EXPORT___;
